import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../common/SnackUI'
import { appRemoveRestoreAction } from '../../redux/toolkit/apps/remove-restore'
import { appListAction } from '../../redux/toolkit/apps/list'
import PropTypes from 'prop-types';

export default function DeleteApp({ appId, state, setState, publisher_id }) {

    // state
    const dispatch = useDispatch()
    const delCat = useSelector(state => state.appRemoveRestore)
    const { status, message } = delCat

    const [snack, setSnack] = useState(false)
    const[otp, setOtp] = useState('')

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        await dispatch(appRemoveRestoreAction({ app_id: appId , otp: otp ,publisher_id:publisher_id}))
        await dispatch(appListAction({ is_deleted: false }))
        setSnack(true)
        setState(false)
    }




    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column" ,"gap":"15px"}}>
                    <DialogContentText id="alert-dialog-description" >
                        Enter The Otp Which Is Send To Your Register Email  ?
                    </DialogContentText>
                    <DialogContentText id="alert-dialog-description" >
                        <TextField
                            id="outlined-basic"
                            label="Enter Otp"
                            variant="outlined"
                           sx={{ width: "100%" }}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                   {otp && <Button onClick={delCatHandle} autoFocus> Agree</Button>}
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}


// DeleteSupport.propTypes = {
//     qns_id: PropTypes.string,
//     state: PropTypes.any,
//     setState: PropTypes.any
// };